<template>
    <div>
        <YesNoModal ref="YesNoModal" />
        <ErrorModal ref="ErrorModal"></ErrorModal>
        <Loader ref="Loader"></Loader>
        <v-container fluid grid-list-xs>
            <v-layout justify-center wrap>
                <v-flex md12>
                    <v-card class="mb-5" elevation="4">
                        <v-layout row wrap ma-4>
                            <v-flex xs12 sm12 md12 lg12 xl12>
                                <v-btn
                                    v-if="HasAccess('CUSTOMER_MANAGEMENT', 'CREATE') || HasAccess('CUSTOMER_MANAGEMENT', 'MODIFY')"
                                    style="float:right;" color="success --darken-2" @click="ShowVenueMaint(true, 0)">
                                    <v-icon>add</v-icon>Add Venue
                                </v-btn>
                                <v-data-table :headers="venueHeaders" :items="VenueList"
                                    :rows-per-page-items="[25, 50, 75, 100]">
                                    <template slot="no-data">There are no records</template>
                                    <template slot="no-results">No matching records found</template>
                                    <template slot="headerCell" slot-scope="{ header }">
                                        <span class="subheading font-weight-light text-success text--darken-3"
                                            v-text="header.text" />
                                    </template>
                                    <template slot="items" slot-scope="{ item }">
                                        <td>{{ item.Name }}</td>
                                        <td>{{ item.RegionName }}</td>
                                        <td>{{ item.ContactTel }}</td>
                                        <td>{{ item.Suburb }}</td>
                                        <td>{{ item.Province }}</td>
                                        <td>{{ item.PostalCode }}</td>
                                        <td style="float:right;">
                                            <v-menu dense bottom left>
                                                <v-btn small slot="activator" color="primary" dark>
                                                    <v-icon>settings</v-icon>
                                                </v-btn>
                                                <div
                                                    v-if="HasAccess('CUSTOMER_MANAGEMENT', 'MODIFY') || HasAccess('CUSTOMER_MANAGEMENT', 'DELETE')">
                                                    <v-list dense v-for="(action, index) in venueActionItems" :key="index">
                                                        <v-list-tile @click="PerformVenueOperation(action, item)"
                                                            v-if="action.access == true">
                                                            <v-list-tile-action>
                                                                <v-icon color="primary darken-2">{{ action.icon }}
                                                                </v-icon>
                                                            </v-list-tile-action>
                                                            <v-list-tile-title>{{ action.title }}</v-list-tile-title>
                                                        </v-list-tile>
                                                    </v-list>
                                                </div>
                                                <div v-else>
                                                    <v-list dense>
                                                        <v-list-tile>
                                                            <v-list-tile-title>
                                                                You have no options
                                                                available
                                                            </v-list-tile-title>
                                                        </v-list-tile>
                                                    </v-list>
                                                </div>
                                            </v-menu>
                                        </td>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="venueDialog">
            <v-card>
                <v-toolbar color="secondary" dark dense>
                    <v-toolbar-title>Venue Maintenance</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab flat small>
                        <v-icon @click="venueDialog = false">close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-form @submit.prevent="SubmitVenueForm" ref="VenueForm" v-model="valid">
                    <v-card-text xs12 mt-3>
                        <v-layout>
                            <v-flex xs6>
                                <v-select v-model="venueForm.RegionID" label="Region" :rules="fieldRules"
                                    :items="regionItems" item-text="Name" item-value="ID"></v-select>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs6>
                                <v-text-field autocomplete="off" aria-autocomplete="none" label="Venue Name"
                                    v-model="venueForm.Name" :rules="fieldRules">
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout justify-start row>
                            <v-flex mr-2>
                                <v-text-field autocomplete="off" aria-autocomplete="none" label="Contact Telephone Number"
                                    v-model="venueForm.ContactTel" mask="phone">
                                </v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field autocomplete="off" aria-autocomplete="none" label="Contact Email Address"
                                    v-model="venueForm.EmailAddress">
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout justify-start row>
                            <v-flex mr-2 md6>
                                <input ref="autocompleteVenue" placeholder="Street Address" class="search-location"
                                    onfocus="value = ''" type="text">
                            </v-flex>
                            <v-flex mr-2 md6></v-flex>
                        </v-layout>
                        <v-layout justify-start row>
                            <v-flex mr-2>
                                <v-text-field autocomplete="off" aria-autocomplete="none" disabled label="Address Line 1"
                                    v-model="venueForm.AddressLine1">
                                </v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field autocomplete="off" aria-autocomplete="none" disabled label="Address Line 2"
                                    v-model="venueForm.AddressLine2">
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout justify-start row>
                            <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                                <v-text-field autocomplete="off" aria-autocomplete="none" disabled label="Suburb"
                                    v-model="venueForm.Suburb"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                                <v-text-field autocomplete="off" aria-autocomplete="none" disabled label="Province"
                                    v-model="venueForm.Province"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                                <v-text-field autocomplete="off" aria-autocomplete="none" disabled type="number"
                                    label="Postal Code" v-model="venueForm.PostalCode">
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                                <v-text-field autocomplete="off" aria-autocomplete="none" label="Latitude"
                                    v-model="venueForm.Latitude">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                                <v-text-field autocomplete="off" aria-autocomplete="none" label="Longitude"
                                    v-model="venueForm.Longitude">
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-card-actions>
                            <v-layout justify-end>
                                <v-btn color="primary" @click="SubmitVenueForm()">Save</v-btn>
                                <v-btn flat @click="venueDialog = false">Cancel</v-btn>
                            </v-layout>
                        </v-card-actions>
                    </v-card-text>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    data() {
        let self = this;
        return {
            e1: 0,
            CustomerID: 0,
            venueDialog: false,
            venueActionItems: [{
                type: "modify",
                title: "Modify",
                access: self.HasAccess("CUSTOMER_MANAGEMENT", "MODIFY"),
                icon: "edit"
            },
            {
                type: "delete",
                title: "Delete",
                access: self.HasAccess("CUSTOMER_MANAGEMENT", "DELETE"),
                icon: "delete"
            }
            ],
            venueHeaders: [{
                sortable: true,
                text: "Venue Name",
                value: "Name"
            },
            {
                sortable: true,
                text: "Region",
                value: "RegionName"
            },
            {
                sortable: true,
                text: "Contact Telephone Number",
                value: "ContactTel"
            },
            {
                sortable: true,
                text: "Suburb",
                value: "Suburb"
            },
            {
                sortable: true,
                text: "Province",
                value: "Province"
            },
            {
                sortable: true,
                text: "Postal Code",
                value: "PostalCode"
            },
            {
                sortable: false,
                align: "right",
                text: "Actions"
            }
            ],
            venueForm: {
                ID: 0,
                CustomerID: 0,
                RegionID: 0,
                Name: null,
                PostalCode: null,
                ContactTel: null,
                EmailAddress: null,
                AddressLine1: null,
                AddressLine2: null,
                Suburb: null,
                Province: null,
                Latitude: null,
                Longitude: null
            },
            fieldRules: [v => !!v || "Field is required"],
            emailRules: [
                v => !!v || "E-mail is required",
                v => /.+@.+/.test(v) || "E-mail must be valid"
            ],
            place: null,
            valid: false,
            venueAdd: false,
            venueID: 0,
            regionItems: [],
            VenueList: [],
        }
    },
    props: ["prop_RegionID"],
    watch: {
        prop_RegionID(newRegion) {
            this.venueForm.RegionID = newRegion;
        },
    },
    mounted() {
        let self = this;
        self.CustomerID = self.$route.params.id;

        self.fetchRegions();
        self.FetchVenues();

        // MAPS
        this.autocompleteVenue = new google.maps.places.Autocomplete(
            self.$refs.autocompleteVenue, {
            types: ["address"]
        }
        );
        this.autocompleteVenue.addListener("place_changed", () => {
            self.place = this.autocompleteVenue.getPlace();
            // venue
            self.venueForm.AddressLine1 =
                self.place.address_components[0].short_name +
                " " +
                self.place.address_components[1].long_name;
            self.venueForm.AddressLine2 = self.place.address_components[2].short_name;
            self.venueForm.Suburb = self.place.address_components[3].short_name;
            self.venueForm.Province = self.place.address_components[5].long_name;

            if (self.place.address_components[7] != null)
                self.venueForm.PostalCode = self.place.address_components[7].long_name;


            self.venueForm.Latitude = self.place.geometry.location.lat();
            self.venueForm.Longitude = self.place.geometry.location.lng();
        });
    },
    methods: {
        FetchVenues() {
            let self = this;

            self.VenueList = [];
            self.get(`CustomerVenue/CustomerID?customerID=${self.CustomerID}`).then(r => {
                self.VenueList = r.data;
            })
        },
        fetchRegions() {
            let self = this;

            self.get('Region').then(r => {
                self.regionItems = r.data;
            })
        },
        ShowVenueMaint(add, id) {
            let self = this;
            self.venueDialog = true;
            self.venueAdd = add;
            self.venueID = id;

            if (add == true) {
                self.venueAdd = add;
            } else {
                self.venueAdd = add;
                self.venueID = id;
                self.fetchVenueDataForModify();
            }
        },
        fetchVenueDataForModify() {
            let self = this;
            self.get("CustomerVenue?id=" + self.venueID).then(response => {
                self.venueForm.ID = response.data.ID;
                self.venueForm.RegionID = response.data.RegionID;
                self.venueForm.Name = response.data.Name;
                self.venueForm.PostalCode = response.data.PostalCode;
                self.venueForm.ContactTel = response.data.ContactTel;
                self.venueForm.EmailAddress = response.data.EmailAddress;
                self.venueForm.AddressLine1 = response.data.AddressLine1;
                self.venueForm.AddressLine2 = response.data.AddressLine2;
                self.venueForm.Suburb = response.data.Suburb;
                self.venueForm.Province = response.data.Province;
                self.venueForm.Latitude = response.data.Latitude;
                self.venueForm.Longitude = response.data.Longitude;
            });
        },
        SubmitVenueForm() {
            let self = this;

            self.venueForm.CustomerID = self.CustomerID;
            let Request = self.venueForm;

            //post
            if (self.venueAdd == true) {
                self
                    .post("CustomerVenue", Request)
                    .then(res => {
                        self.VenueList.push(res.data);
                        self.venueDialog = false;
                        self.place = null;
                        // clear form
                        self.venueForm = {
                            ID: 0,
                            Name: "",
                            PostalCode: null,
                            ContactTel: null,
                            EmailAddress: null,
                            AddressLine1: null,
                            AddressLine2: null,
                            Suburb: null,
                            Province: null,
                            Latitude: null,
                            Longitude: null
                        };
                    })
                    .catch(err => {
                        console.log(err);
                        self.$refs.ErrorModal.show();
                        self.$refs.ErrorModal.setText("Failed to create venue");
                    });
            } else {
                // update
                self
                    .put("CustomerVenue?id=" + self.venueID, Request)
                    .then(r => {
                        self.FetchVenues();
                        self.venueDialog = false;
                        self.place = null;
                        // clear form
                        self.venueForm = {
                            ID: 0,
                            Name: "",
                            PostalCode: null,
                            ContactTel: null,
                            EmailAddress: null,
                            AddressLine1: null,
                            AddressLine2: null,
                            Suburb: null,
                            Province: null,
                            Latitude: null,
                            Longitude: null
                        };
                    })
                    .catch(error => {
                        console.log(err);
                        self.$refs.ErrorModal.show();
                        self.$refs.ErrorModal.setText("Failed to update venue");
                    });
            }
        },
        PerformVenueOperation(action, item) {
            let self = this;
            switch (action.type.toUpperCase()) {
                case "MODIFY": {
                    self.modifyVenueItem(item);
                }
                    break;
                case "DELETE": {
                    self.deleteVenueItem(item);
                }
                    break;
            }
        },
        modifyVenueItem(item) {
            let self = this;
            self.ShowVenueMaint(false, item.ID);
        },
        deleteVenueItem(item) {
            let self = this;

            item.IsDeleted = true;
            let Request = item;

            self.$refs.YesNoModal.show(
                "Are you sure you want to delete this venue?",
                function (yes) {
                    if (yes == true) {
                        self.put(`CustomerVenue?id=${item.ID}`, Request)
                            .then(result => {
                                if (result.data == true) {
                                    var index = self.VenueList.indexOf(item);
                                    if (index > -1) {
                                        self.VenueList.splice(index, 1);
                                    }
                                }
                            })
                            .catch(error => {
                                self.$refs.ErrorModal.show();
                                self.$refs.ErrorModal.setText(error.toString());
                            });
                    }
                }
            );
        },
    },
}
</script>

<style></style>